import { ConcursosComerciales } from "./types/concursos";
import { fetchWithRetry } from "../client";

export async function fetchProcesosComerciales(): Promise<
  ConcursosComerciales[]
> {
  const res = await fetchWithRetry<{ data: ConcursosComerciales[] }>(
    `/concursos-comerciales`,
  );

  return res.data;
}
